import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "@material-tailwind/react";

interface Props {
  open: boolean;
  toggleOpen: () => void;
  title: string;
  body?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}


const ConfirmOrCancel = ({ open, toggleOpen, title, body, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel' }: Props) => {
  const onClick = (fn) => {
    if (fn) {
      fn();
    }
    return toggleOpen();
  }

  return (
    <>
      <Dialog open={open} handler={toggleOpen}>
        <DialogHeader>{title}</DialogHeader>
        {body && <DialogBody divider>
          {body}
        </DialogBody>}
        <DialogFooter>
          <Button
            variant="text"
            color="red"
            onClick={() => onClick(onCancel)}
            className="mr-1"
          >
            <span>{cancelLabel}</span>
          </Button>
          <Button variant="gradient" color="green" onClick={() => onClick(onConfirm)}>
            <span>{confirmLabel}</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}

export default ConfirmOrCancel;